module.exports = __webpack_public_path__ + "img/hm.384101a6.svg";